import Vue from 'vue';
import Vuex from 'vuex';
import {getPersonInfo} from '../axios/api';


import shopro from './modules/shopro.js'
import user from './modules/user.js'
import cart from './modules/cart.js'

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		shopro,
		user,
    cart
	}
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js